<template>
  <div class="modal-content">
    <hero-image>
      <template v-slot:images>
        <div class="hero-image"> 
          <img
            :src="heroImage"
            height="320"
            width="320"
          >
        </div>
      </template>
    </hero-image>
    <!-- TODO 翻訳対応 -->
    <p class="confirm-text" v-html="`${heroName}<br>${$t('confirm.text001')}`" />
    <div class="buttons">
      <button
        class="button no-button"
        :class="[this.$route.params.lang]"
        @click="hideModal"
      />
      <button
        class="button yes-button"
        :class="[this.$route.params.lang]"
        @click="vote"
      />
    </div>
  </div>
</template>

<script>
import Api from '@libraries/api/'
import RequestVote from '@requests/vote'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import HeroImage from '@components/hero/hero-image'

import localeModal from '@locales/modal'

export default {
  name: 'modal-vote-confirm',
  $messages: localeModal,
  components: {
    HeroImage
  },
  computed: {
    ...mapState('modal', ['modal']),
    ...mapGetters('login', ['voteKey']),
    heroId() {
      return this.modal.props.id
    },
    heroName() {
      return this.modal.props.name
    },
    seriesId() {
      return this.modal.props.seriesId
    },
    heroImage() {
      if (!this.modal.props) return
      return require(`@images/hero/faces/${this.modal.props.id}.png`)
    },
  },
  methods: {
    ...mapActions('modal', ['hideModal']),
    ...mapMutations('login', ['setVoteState', 'setResetTime']),
    vote() {
      this.setVoteState(true)
      this.setResetTime()
      Api.call(new RequestVote({heroId:this.heroId, voteKey:this.voteKey}))
        .then(() => {
          this.$router.push(`/${this.$route.params.lang}/series/${this.seriesId}/heroes/${this.heroId}/voted`)
          window.scrollTo(0, 0)
          this.hideModal()
          this.setVoteState(true)
          this.setResetTime()
        })
        .catch(({error}) => {
          this.$router.push(`/${this.$route.params.lang}/error`)
          window.scrollTo(0, 0)
          this.hideModal()
          throw error
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.hero-image-wrapper {
  background-image: url(~@images/vote/bg_vote-confirm.png);
  background-repeat: no-repeat;
  background-position: center;
  font-size: $fs-large;
  margin: 0 auto 20px;
  width: 486px;
  height: 472px;
  position: relative;
}
.hero-image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.confirm-text {
  background-image: url(~@images/bg_hero-text.png);
  background-repeat: no-repeat;
  background-position: center;
  font-size: $fs-xlarge;
  text-align: center;
  margin: -60px 0 20px;
  padding: 10px 0;
}
.buttons {
  display: flex;
  justify-content: center;
}
.button {
  background-repeat: no-repeat;
  background-size: 236px 113px;
  width: 236px;
  height: 113px;
  text-shadow: $ts-base;
  @include tap-event();
  &.no-button {
    &.ja-JP {
      background-image: url(#{$img-path}vote/ja-JP/btn_no.png);
    }
    &.de-DE {
      background-image: url(#{$img-path}vote/de-DE/btn_no.png);
    }
    &.en-GB {
      background-image: url(#{$img-path}vote/en-GB/btn_no.png);
    }
    &.en-US {
      background-image: url(#{$img-path}vote/en-US/btn_no.png);
    }
    &.es-ES {
      background-image: url(#{$img-path}vote/es-ES/btn_no.png);
    }
    &.es-MX {
      background-image: url(#{$img-path}vote/es-MX/btn_no.png);
    }
    &.fr-CA {
      background-image: url(#{$img-path}vote/fr-CA/btn_no.png);
    }
    &.fr-FR {
      background-image: url(#{$img-path}vote/fr-FR/btn_no.png);
    }
    &.it-IT {
      background-image: url(#{$img-path}vote/it-IT/btn_no.png);
    }
    &.pt-BR {
      background-image: url(#{$img-path}vote/pt-BR/btn_no.png);
    }
    &.zh-TW {
      background-image: url(#{$img-path}vote/zh-TW/btn_no.png);
    }
  }
  &.yes-button {
    margin-left: 10px;
    &.ja-JP {
      background-image: url(#{$img-path}vote/ja-JP/btn_yes.png);
    }
    &.de-DE {
      background-image: url(#{$img-path}vote/de-DE/btn_yes.png);
    }
    &.en-GB {
      background-image: url(#{$img-path}vote/en-GB/btn_yes.png);
    }
    &.en-US {
      background-image: url(#{$img-path}vote/en-US/btn_yes.png);
    }
    &.es-ES {
      background-image: url(#{$img-path}vote/es-ES/btn_yes.png);
    }
    &.es-MX {
      background-image: url(#{$img-path}vote/es-MX/btn_yes.png);
    }
    &.fr-CA {
      background-image: url(#{$img-path}vote/fr-CA/btn_yes.png);
    }
    &.fr-FR {
      background-image: url(#{$img-path}vote/fr-FR/btn_yes.png);
    }
    &.it-IT {
      background-image: url(#{$img-path}vote/it-IT/btn_yes.png);
    }
    &.pt-BR {
      background-image: url(#{$img-path}vote/pt-BR/btn_yes.png);
    }
    &.zh-TW {
      background-image: url(#{$img-path}vote/zh-TW/btn_yes.png);
    }
  }
}
</style>
